import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDash = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "m4.233 4 .562-3H6.83l-.563 3h4.966l.562-3h2.035l-.562 3H16v2h-3.107l-.75 4H15v2h-3.232l-.563 3H9.17l.563-3H4.767l-.562 3H2.17l.563-3H0v-2h3.108l.75-4H1V4zm1.66 2-.75 4h4.965l.75-4z",
		clipRule: "evenodd"
	})
});
export default SvgDash;
